import { render, staticRenderFns } from "./custIndex.vue?vue&type=template&id=690dbfec"
import script from "./custIndex.vue?vue&type=script&lang=js"
export * from "./custIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports